import { boolean, literal, number, object, string, z } from "zod";

export const LadyMinV2MainPhotoDTORaw = object({
  mediaName: string().optional(),
  photoId: number().optional(),
  photoType: string(), //TODO: literal("PHOTO_LADY"), // add more types according to the task in notion
  type: literal("photo"),
  isFavorite: boolean().optional(),
  urlPhoto: string().optional(),
  urlThumbnailMedium: string().optional(),
  urlThumbnailSmall: string().optional(),
});

export type LadyMinV2MainPhotoDTORaw = z.infer<typeof LadyMinV2MainPhotoDTORaw>;

export const LadyMinV2DTORaw = object({
  id: number(),
  mainPhotoDTO: LadyMinV2MainPhotoDTORaw.optional(),
  mainPhotoID: number().optional(),
  firstName: string(),
  birthday: number().optional(),
  registrationDate: number().optional(),
  agencyId: number().optional(),
  lastName: string(),
  from: string(),
  hasIntroVideo: boolean(),
  appearanceType: string().optional(),
  // loadedStage: string().optional(),
  // partialId: number().optional(),
  age: number().optional(),
  isOnline: boolean().optional(),
  value: number().optional(),
  isGiftsAvailable: boolean(),
  isVideochatAvailable: boolean(),
  isBirthdaySoon: boolean(),
  isNewProfile: boolean(),
  isFavorite: boolean().optional(),
  url: string().optional(),
});

export const LadyMinV2DTOPhotoSrcs = object({
  small: string(),
  medium: string(),
  large: string(),
});

export const LadyMinV2DTO = LadyMinV2DTORaw.extend({
  photoSrcs: LadyMinV2DTOPhotoSrcs,
});

export type LadyMinV2DTORaw = z.infer<typeof LadyMinV2DTORaw>;
export type LadyMinV2DTOPhotoSrcs = z.infer<typeof LadyMinV2DTOPhotoSrcs>;
export type LadyMinV2DTO = z.infer<typeof LadyMinV2DTO>;
